/* eslint-disable */
export default {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'ItemField',
        possibleTypes: [
          {
            name: 'RichTextField',
          },
          {
            name: 'NumberField',
          },
          {
            name: 'MultilistField',
          },
          {
            name: 'LookupField',
          },
          {
            name: 'LinkField',
          },
          {
            name: 'TextField',
          },
          {
            name: 'IntegerField',
          },
          {
            name: 'ImageField',
          },
          {
            name: 'DateField',
          },
          {
            name: 'CheckboxField',
          },
          {
            name: 'NameValueListField',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Item',
        possibleTypes: [
          {
            name: 'UnknownItem',
          },
          {
            name: 'StyleguideComponentParamsRenderingParameters',
          },
          {
            name: 'C__StandardTemplate',
          },
          {
            name: 'C__Route',
          },
          {
            name: 'RenderEngineType',
          },
          {
            name: 'StyleguideTracking',
          },
          {
            name: 'StyleguideSitecoreContext',
          },
          {
            name: 'StyleguideSection',
          },
          {
            name: 'StyleguideRouteFields',
          },
          {
            name: 'StyleguideMultilingual',
          },
          {
            name: 'StyleguideLayoutTabsTab',
          },
          {
            name: 'StyleguideLayoutTabs',
          },
          {
            name: 'StyleguideLayoutReuse',
          },
          {
            name:
              'StyleguideItemLinkItemTemplate',
          },
          {
            name: 'StyleguideFieldUsageText',
          },
          {
            name:
              'StyleguideFieldUsageRichText',
          },
          {
            name: 'StyleguideFieldUsageNumber',
          },
          {
            name: 'StyleguideFieldUsageLink',
          },
          {
            name:
              'StyleguideFieldUsageItemLink',
          },
          {
            name: 'StyleguideFieldUsageImage',
          },
          {
            name: 'StyleguideFieldUsageFile',
          },
          {
            name: 'StyleguideFieldUsageDate',
          },
          {
            name: 'StyleguideFieldUsageCustom',
          },
          {
            name:
              'StyleguideFieldUsageContentList',
          },
          {
            name:
              'StyleguideFieldUsageCheckbox',
          },
          {
            name:
              'StyleguideExplanatoryComponent',
          },
          {
            name:
              'StyleguideContentListItemTemplate',
          },
          {
            name: 'StyleguideComponentParams',
          },
          {
            name:
              'StyleguideAngularLazyLoading',
          },
          {
            name: 'GraphQLIntegratedDemo',
          },
          {
            name: 'GraphQLConnectedDemo',
          },
          {
            name: 'ExampleCustomRouteType',
          },
          {
            name: 'ContentBlock',
          },
          {
            name: 'C__AppRoute',
          },
          {
            name: 'JsonRendering',
          },
          {
            name: 'JavaScriptRendering',
          },
          {
            name: 'JSSLayout',
          },
          {
            name: 'App',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'RenderingOptions',
        possibleTypes: [
          {
            name: 'JsonRendering',
          },
          {
            name: 'JavaScriptRendering',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Layout',
        possibleTypes: [
          {
            name: 'JSSLayout',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'AppRoute',
        possibleTypes: [
          {
            name: 'ExampleCustomRouteType',
          },
          {
            name: 'C__AppRoute',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Caching',
        possibleTypes: [
          {
            name: 'JsonRendering',
          },
          {
            name: 'JavaScriptRendering',
          },
        ],
      },
    ],
  },
};
